import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Select } from '@mews-commander/ui';
import { getLanguageOptions } from '@mews-commander/legacy-entities/src/ducks/languages';
import { useCommanderSelector } from '@mews-commander/utils';

interface LanguageSwitcherProps {
    productLanguages: string[];
    onLanguageChange: (languageCode: string) => void;
    selectedLanguageCode: string;
}

export const LanguageSwitcher = ({
    productLanguages,
    onLanguageChange,
    selectedLanguageCode,
}: LanguageSwitcherProps) => {
    const languageOptions = useCommanderSelector(getLanguageOptions);

    return (
        <Select
            name="localization"
            onChange={onLanguageChange}
            options={pipe(
                languageOptions,
                array.filter((option) => !!option.value && productLanguages.includes(option.value))
            )}
            selected={selectedLanguageCode}
            size="small"
            inline
        />
    );
};
